import {geo} from '../geo/geo'; // Import the geo module for location handling
import { api } from '../api/api'

import { store } from '../stores/userStore';  // Import the store



const cognitoConfig = {
    Region: process.env.VUE_APP_COGNITO_REGION,
    UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    Domain: process.env.VUE_APP_COGNITO_DOMAIN,
    RedirectUri: process.env.VUE_APP_REDIRECT_URI,
    Scopes: ['email', 'openid', 'phone']
  };

  
export const auth = {


  async generateCodeChallenge(codeVerifier) {
    // Fallback for non-secure contexts
    if (!crypto.subtle) {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      // Using a basic hash function as fallback
      let hash = 0;
      for (let i = 0; i < data.length; i++) {
        hash = ((hash << 5) - hash) + data[i];
        hash = hash & hash;
      }
      return btoa(String(hash))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    }
    
    // Original secure implementation
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  },

  generateCodeVerifier() {
    console.log('Generating code verifier');
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  },

  // async login() {
  //   console.log('Logging in');
  //   // Get location before login to include it in auth flow if needed
  //   geo.getLocation();
    
  //   const codeVerifier = this.generateCodeVerifier();
  //   const codeChallenge = await this.generateCodeChallenge(codeVerifier);
    
  //   // Store the code verifier for later use
  //   localStorage.setItem('codeVerifier', codeVerifier);
    
  //   const queryParams = new URLSearchParams({
  //     client_id: cognitoConfig.ClientId,
  //     response_type: 'code',
  //     scope: cognitoConfig.Scopes.join(' '),
  //     redirect_uri: cognitoConfig.RedirectUri,
  //     code_challenge_method: 'S256',
  //     code_challenge: codeChallenge,
  //     auth_flow: 'USER_SRP_AUTH'
  //   });
    
  //   window.location.href = `https://${cognitoConfig.Domain}/login?${queryParams}`;
  // },
  
  async login() { 
    // pop up a modal with the SignInView component
  store.showSignInModal = true;
    
  },

  logout() {
    console.log('Logging out');
    localStorage.removeItem('authCode');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('codeVerifier');
    localStorage.removeItem('user');
    // Don't remove location on logout if you want to persist it between sessions
    // If you want to clear location on logout, uncomment the next line
    // localStorage.removeItem('userLocation');
    
    // const queryParams = new URLSearchParams({
    //   client_id: cognitoConfig.ClientId,
    //   logout_uri: cognitoConfig.RedirectUri
    // });
    
    // window.location.href = `https://${cognitoConfig.Domain}/logout?${queryParams}`;
    // pop up and laert that says logged out
    alert('You have been logged out.');
    store.isAuthenticated = false;
    

  },

  /**
   * Centralized helper to check for an existing user and create one if missing.
   * Returns the backend response for the existing or newly created user.
   */
  async ensureUserExists(userPayload = {}) {
    try {
      const checkResp = await api.apiQuery('POST', '/private/checkUser', { user: userPayload })
      if (checkResp?.exists) {
        return checkResp
      }
      const createResp = await api.apiQuery('POST', '/private/createUser', { user: userPayload })
      return createResp
    } catch (err) {
      console.error('auth.ensureUserExists error:', err)
      throw err
    }
  },

  async handleRedirect() {
    console.log('Handling redirect');
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const codeVerifier = localStorage.getItem('codeVerifier');
    
    if (code && codeVerifier) {
        console.log('Code and code verifier found');
      localStorage.setItem('authCode', code);
      
      try {
        console.log('Exchanging code for token');
        const tokenEndpoint = `https://${cognitoConfig.Domain}/oauth2/token`;
        const response = await fetch(tokenEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: cognitoConfig.ClientId,
            redirect_uri: cognitoConfig.RedirectUri,
            code: code,
            code_verifier: codeVerifier
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error('Token exchange error:', errorData);
          throw new Error(`Failed to exchange code for token: ${errorData.error}`);
        }
        console.log('Successfully exchanged code for token');

        const tokens = await response.json();
        
       // Decode both tokens to get user information
        const accessPayload = JSON.parse(atob(tokens.access_token.split('.')[1]));
        const idPayload = tokens.id_token ? JSON.parse(atob(tokens.id_token.split('.')[1])) : null;
        const cognitoUserId = accessPayload.sub;  // 'sub' claim contains the Cognito user ID
        const userEmail = idPayload?.email || accessPayload.email; // Try to get email from either token
  
        
        // Check if user exists in your database
        try {
          // Build minimal payload for backend user check/create
          const location = geo.getCurrentPosition();
          const userPayload = {
            cognitoId: cognitoUserId,
            email: userEmail,
            location
          };

          // Reuse centralized helper to check/create user in backend
          const userResp = await this.ensureUserExists(userPayload);

          // persist returned user object (backend may return shape { user: {...} } or the user directly)
          const persistedUser = userResp?.user ?? userResp;
          console.log('User check/create response:', persistedUser);
          localStorage.setItem('user', JSON.stringify(persistedUser));
        } catch (error) {
          console.error('Error checking/creating user record:', error);
        }
        

        // Clear code verifier as it's no longer needed
        localStorage.removeItem('codeVerifier');
        
        // Store tokens and set expiration
        localStorage.setItem('refreshToken', tokens.refresh_token);
        localStorage.setItem('accessToken', tokens.access_token);
        
        // Set token expiration to 1 day (24 hours)
        const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
        localStorage.setItem('tokenExpiration', expirationTime);
        
        return tokens.access_token;
      } catch (error) {
        console.error('Error exchangin code for token:', error);
        return null;
      }
    }
    return null;
  },

  isAuthenticated() {
    //return !!localStorage.getItem('accessToken');
    // make this more robust by checking expiration?
    return !!localStorage.getItem('accessToken') &&
           (!!localStorage.getItem('tokenExpiration') &&
            new Date().getTime() < parseInt(localStorage.getItem('tokenExpiration')));
  },
  
  getUser() { 
    return JSON.parse(localStorage.getItem('user'));
  },

  async refreshAccessToken() {
    console.log('Refreshing token');
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      return null;
    }

    try {
      const tokenEndpoint = `https://${cognitoConfig.Domain}/oauth2/token`;
      const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          grant_type: 'refresh_token',
          client_id: cognitoConfig.ClientId,
          refresh_token: refreshToken
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Token refresh error:', errorData);
        throw new Error(`Failed to refresh token: ${errorData.error}`);
      }

      const tokens = await response.json();
      console.log('Successfully refreshed token');

      // Update access token and its expiration to 1 day
      localStorage.setItem('accessToken', tokens.access_token);
      const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000);
      localStorage.setItem('tokenExpiration', expirationTime);
      
      return tokens.access_token;
    } catch (error) {
      console.error('Error refreshing token:', error);
      // If refresh fails, user needs to login again
      this.logout();
      return null;
    }
  },

  async getToken() {
    console.log('Getting token from storage');
    const accessToken = localStorage.getItem('accessToken');
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    
    if (!accessToken || !tokenExpiration) {
        console.log('No token found or token expired');
      return null;
    }

    // Check if token is expired or will expire in the next 5 minutes
    const isExpired = new Date().getTime() > (parseInt(tokenExpiration) - 5 * 60 * 1000);
    
    if (isExpired) {
      // Token is expired or will expire soon, try to refresh it
      console.log('Token expired or will expire soon, refreshing');
      return await this.refreshAccessToken();
    }
    
    return accessToken;
  },
  

};

